'use client'

import React, { MouseEventHandler } from 'react'
import { isArray } from 'lodash'

export const Accordion = (
  {
    children,
    customClass,
  }: {
    children?: React.ReactNode[] | string[] | string | React.ReactNode
    customClass?: string
  },
) => {
  return (
    <div className={customClass}>
      {
        isArray(children) ? children.map(child => child) : children
      }
    </div>
  )
}
